import { render, staticRenderFns } from "./OsTemplate.vue?vue&type=template&id=349e8fb8&scoped=true"
import script from "./OsTemplate.vue?vue&type=script&lang=js"
export * from "./OsTemplate.vue?vue&type=script&lang=js"
import style0 from "./OsTemplate.vue?vue&type=style&index=0&id=349e8fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e8fb8",
  null
  
)

export default component.exports